import axios from "axios";
import { LOGIN_API_URL } from "../constants";

/**
 * Authenticates user with Microsoft OAuth code via Cognito CUSTOM_AUTH flow
 * 
 * This bypasses Cognito's built-in Microsoft Identity Provider, which has
 * limitations with multi-tenant authentication (personal + organizational accounts).
 * 
 * Instead, we:
 * 1. Get authorization code from Microsoft OAuth (safe - no tokens in browser!)
 * 2. Send code + PKCE verifier to backend
 * 3. Backend exchanges code for tokens with PKCE verification (server-to-server, secure)
 * 4. Backend uses tokens with Cognito Lambda triggers to validate via Microsoft Graph API
 * 5. Returns Cognito tokens (no issuer validation conflicts!)
 */
export const authenticateWithMicrosoft = async ({ code, codeVerifier }) => {
  try {
    const response = await axios.post(
      `${LOGIN_API_URL}/oauth2/microsoft-auth`,
      {
        code, // Authorization code
        code_verifier: codeVerifier, // PKCE verifier for secure token exchange
      },
      {
        withCredentials: true, // Important: Send/receive cookies
      }
    );

    return response.data;
  } catch (error) {
    console.error("Microsoft authentication error:", error);
    throw error;
  }
};

